import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserPermission } from '../enums/user-permission.enum';
import { Observable, of, throwError } from 'rxjs';
import { MdrDashboardsService } from '../../mdr-dashboards/services/mdr-dashboards.service';
import { ConfigService } from '../../../services/config/config.service';
import { catchError, filter, map } from 'rxjs/operators';
import { IdentityService } from '../services/identity.service';

@Injectable({
    providedIn: 'root',
})
class CqGuardService {
    constructor(
        private router: Router,
        private authService: AuthService,
        private identityService: IdentityService,
        private mdrService: MdrDashboardsService,
        private configService: ConfigService,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        if (this.identityService.companyLoaded) {
            return of(this.redirectToCQorDashboard());
        }

        return this.identityService.companyLoaded$.pipe(
            filter((isLoaded) => isLoaded),
            catchError((err) => {
                return throwError(() => err);
            }),
            map(() => {
                return this.redirectToCQorDashboard();
            }),
        );
    }

    public redirectToCQorDashboard() {
        if (!this.authService.jwtUser) {
            return false;
        }

        if (
            (!this.configService.getFeaturesConfig().cq_beta_company_list ||
                this.configService.getFeaturesConfig().cq_beta_company_list.length === 0 ||
                true) &&
            !this.authService.jwtUser.Permissions.includes(UserPermission.QuestionnaireQuestionsRead) &&
            !this.authService.jwtUser.Permissions.includes(UserPermission.QuestionnaireQuestionWrite)
        ) {
            return this.router.parseUrl('/dashboard/browse');
        }

        if (this.identityService.companyLoaded && this.mdrService.isPremiumEnterprise(this.identityService.company)) {
            const isAllowed =
                this.authService.hasAtLeastOneRole([
                    UserPermission.QuestionnaireQuestionWrite,
                    UserPermission.QuestionnaireQuestionsRead,
                ]) ||
                this.authService.jwtUser.PermissionExist([
                    UserPermission.QuestionnaireQuestionWrite,
                    UserPermission.QuestionnaireQuestionsRead,
                ]);

            return (
                isAllowed ||
                this.configService.getFeaturesConfig().cq_beta_company_list.includes(this.authService.jwtUser.CompanyId) ||
                this.router.parseUrl('/dashboard/browse')
            );
        }

        return this.router.parseUrl('/dashboard/browse');
    }
}

export const CqGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    return inject(CqGuardService).canActivate(next, state);
};
